import KeyboardView from './KeyboardView';

export default KeyboardView;
